import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss'],
    standalone: false
})
export class ConfirmationModalComponent {
    @Input() title: string;
    @Input() message: string;
    @Input() confirmText = 'OK';
    @Input() cancelText = 'Annuler';
    @Input() showCancel = true;
    @Input() confirmButtonClass = 'btn-primary';

    constructor(public activeModal: NgbActiveModal) {}
}
